import api from './api';

const systemService = {
    // Get server storage information
    getServerStorage: async () => {
        const response = await api.get('/admin/server-storage');
        return response.data;
    }
};

export default systemService;
